export default __webpack_public_path__ + "static/Крысиные бега_9-597233e12d245a75276e19c6c4a03616.jpg";